import React, { createContext, useState, useContext } from "react";
import Loader from "../components/common/ui/loader"; // adjust path if needed

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {loading && <Loader />}
      {children}
    </LoaderContext.Provider>
  );
};

// custom hook for easy access
export const useLoader = () => useContext(LoaderContext);
